module.exports = __webpack_public_path__ + "img/collar topline length peter pen or flat 17=1.27ec899b.png";